import { useEffect, useState } from "react";
import Select from "react-select";
import api from "../Axios/api";
import ReceiptTable from "./Receipt";
import ComputerTable from "./Computer";
import Loader from "../common/Loader";
const Dashboard = () => {
  // --- State variables ---
  const [facLoc, setFacLoc] = useState([]);
  const [itemGroups, setItemGroups] = useState([]);
  const [dropItems, setDropItems] = useState([]);
  const [staffName, setStaffName] = useState([]);

  // --- Selected values ---
  const [selectedFactory, setSelectedFactory] = useState(null);
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [selectedStaff, setSelectedStaff] = useState(null);
  const [selectedItem, setSelectedItem] = useState(null);

  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  const [receipt, setReceipt] = useState([]);
  const [computer, setComputer] = useState([]);
  const [loading, setLoading] = useState(false);
  const fetchFactoryLocations = async () => {
    try {
      const res = await api.get(`/factory-location/get-factory-location`);
      const newData = res.data.map((location) => ({
        value: location._id,
        label: location.fectory_loca_name,
      }));
      setFacLoc(newData);
    } catch (error) {
      console.error("Error fetching factory locations:", error);
    }
  };
  const staffNames = async () => {
    await api
      .get(`/staff/get-staff-name`)
      .then((res) => {
        const newData = res.data.map((staff) => ({
          value: staff._id,
          label: staff.staff_name,
        }));
        setStaffName(newData);
      })
      .catch((err) => console.log(err));
  };
  const fetchItemGroups = async () => {
    try {
      const res = await api.get(`/purchase-item-category/get-name`);
      const newData = res.data.map((cat) => ({
        value: cat._id,
        label: cat.itemcat_title,
      }));
      setItemGroups(newData);
    } catch (error) {
      console.error("Error fetching item groups:", error);
    }
  };
  const fetchGroupItems = async (catId, factoryId) => {
    if (!catId || !factoryId) {
      setDropItems([]);
      return;
    }

    try {
      const res = await api.get(
        `/purchase-item/get-item-by-catloc/?catId=${catId}&factory=${factoryId}`
      );
      const newData = res.data.map((item) => ({
        value: item._id,
        label: item.item_title,
      }));
      setDropItems(newData);
    } catch (error) {
      console.error("Error fetching group items:", error);
    }
  };
  useEffect(() => {
    fetchFactoryLocations();
    fetchItemGroups();
    staffNames();
  }, []);
  useEffect(() => {
    if (selectedGroup && selectedFactory) {
      const catId = selectedGroup.value.split("_")[0];
      const factoryId = selectedFactory.value;
      fetchGroupItems(catId, factoryId);
    }
  }, [selectedGroup, selectedFactory]);

   const handleSearch = async () => {
    try {
      setLoading(true);
      const params = {};
      if (selectedItem?.value) params.itemId = selectedItem.value;
      if (selectedStaff?.value) params.user = selectedStaff.value;
      if (fromDate) params.fromDate = fromDate;
      if (toDate) params.toDate = toDate;

      const res = await api.get("/search/get", { params });

      // console.log(res.data);
      setReceipt(res.data.receiptData);
      setComputer(res.data.computerData);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };
 
const customStyles = {
  control: (base) => ({ ...base, borderColor: "#d1d5db", boxShadow: "none" }),
  menuPortal: (base) => ({ ...base, zIndex: 99999 }),
  menu: (base) => ({ ...base, zIndex: 99999 }),
};
  return (
    <div className="w-[95%] mx-auto">
      {/* Header */}
      <div className="h-10 px-2 mt-5 flex justify-between items-center text-violet-500 font-bold rounded-md bg-[#fdfdfd] shadow mb-2">
        <div className="text-lg">Stocks History</div>
      </div>

      {/* Filters Section */}
      <div className="p-6 mt-4 w-full flex flex-wrap items-end justify-between gap-4 bg-white shadow-md rounded-lg">
        {/* Left Side — Filters */}
        <div className="flex flex-wrap items-end gap-4">
          {/* Factory Selector */}
          <div className="flex flex-col w-[220px]">
            <label className="mb-1 text-gray-700 font-medium">
              Factory Location
            </label>
            <Select
              options={facLoc}
              value={selectedFactory}
              onChange={setSelectedFactory}
              placeholder="Select Factory"
              isSearchable
              isClearable
              styles={customStyles}
                menuPortalTarget={typeof document !== "undefined" ? document.body : null}
                menuPosition="fixed"
                menuPlacement="auto"
            />
          </div>

          {/* Item Group Selector */}
          <div className="flex flex-col w-[220px]">
            <label className="mb-1 text-gray-700 font-medium">
              Item Category
            </label>
            <Select
              options={itemGroups}
              value={selectedGroup}
              onChange={setSelectedGroup}
              placeholder="Select Category"
              isSearchable
              isClearable
              styles={customStyles}
                menuPortalTarget={typeof document !== "undefined" ? document.body : null}
                menuPosition="fixed"
                menuPlacement="auto"
            />
          </div>

          {/* Item Selector */}
          <div className="flex flex-col w-[220px]">
            <label className="mb-1 text-gray-700 font-medium">Item</label>
            <Select
              options={dropItems}
              value={selectedItem}
              onChange={setSelectedItem}
              placeholder="Select Item"
              isSearchable
              isClearable
              styles={customStyles}
              menuPortalTarget={typeof document !== "undefined" ? document.body : null}
                menuPosition="fixed"
                menuPlacement="auto"
            />
          </div>

          {/* Staff Selector */}
          <div className="flex flex-col w-[220px]">
            <label className="mb-1 text-gray-700 font-medium">Staff</label>
            <Select
              options={staffName}
              value={selectedStaff}
              onChange={setSelectedStaff}
              placeholder="Select Staff"
              isSearchable
              isClearable
              styles={customStyles}
              menuPortalTarget={typeof document !== "undefined" ? document.body : null}
                menuPosition="fixed"
                menuPlacement="auto"
            />
          </div>

          {/* From Date Selector */}
          <div className="flex flex-col w-[180px]">
            <label className="mb-1 text-gray-700 font-medium">From</label>
            <input
              type="date"
              value={fromDate}
              onChange={(e) => setFromDate(e.target.value)}
              className="border border-gray-300 rounded-md px-2 py-1 focus:outline-none focus:ring-2 focus:ring-violet-400"
            />
          </div>

          {/* To Date Selector */}
          <div className="flex flex-col w-[180px]">
            <label className="mb-1 text-gray-700 font-medium">To</label>
            <input
              type="date"
              value={toDate}
              onChange={(e) => setToDate(e.target.value)}
              className="border border-gray-300 rounded-md px-2 py-1 focus:outline-none focus:ring-2 focus:ring-violet-400"
            />
          </div>
        </div>

        {/* Right Side — Button */}
        <div className="flex justify-end w-auto">
          <button
            onClick={handleSearch}
            className="bg-violet-500 text-white px-6 py-2 rounded-md hover:bg-violet-600 transition"
          >
            Search
          </button>
        </div>
      </div>
       {loading ? (
        <Loader/>
      ) : (
        <div className="flex flex-col md:flex-row gap-6 mt-5">
  {/* Receipt Table */}
  {receipt?.length > 0 ? (
    <div className="w-full md:w-1/2">
      <ReceiptTable receiptData={receipt} />
    </div>
  ) : (
  " "
  )}

  {/* Computer Table */}
  {computer?.length > 0 ? (
    <div className="w-full md:w-1/2">
      <ComputerTable computerData={computer} />
    </div>
  ) : (
    " "
  )}
</div>

      )}
    </div>
  );
};

export default Dashboard;
